<template>
    <j-page class="trend-page-layout" v-loading="pageLoading">
        <div slot="search">
            <el-badge class="trend-page-search" value="应用中" type="primary" :hidden="conds.length < 1">
                <el-button icon="el-icon-finished" type="info" @click="showSearch = true">搜索条件</el-button>
            </el-badge>
            <el-button type="primary" icon="el-icon-plus"  @click="addDgmxEvent">新增</el-button>
            <!--            <el-button v-if="$store.state.user.roleId == 1" type="info"  @click="exportEvent">导出</el-button>-->
        </div>
        <div slot="table">
            <el-table class="table-fix" v-loading="tableLoading" :data="tableData" height="100%">
                <template v-if="tableCell.length > 0">
                    <template v-for="field in tableCell">
                        <!--       脱敏-->
                        <el-table-column v-if="field.fieldDesensitive" :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip>
                            <template slot-scope="{row}">
                                <!--        联系方式脱敏单独处理-->
                                <j-sensitive v-if="field.fieldInputType == 1 && field.fieldDicKeyInputFormat === 2" :rule="[3, -4]" :value="row[field.fieldEng]" />
                                <!--        系统字段已知规则匹配、若匹配不到默认使用联系方式脱敏规则-->
                                <j-sensitive v-else :rule="desensitiveRule[field.fieldEng] || [3, -4]" :value="row[field.fieldEng]" />
                            </template>
                        </el-table-column>
                        <!--       单选转义值-->
                        <el-table-column v-else-if="field.fieldInputType == 6 || field.fieldInputType == 8" :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip>
                            <template slot-scope="{row}">
                                <!--        字典项-->
                                <j-dictionary v-if="field.fieldDicKeyInputFormat == 1" :code="field.fieldDicKey" :api="'/api/dictionaryItems/' + field.fieldDicKey + '/negot-items'" :value="row[field.fieldEng]" />
                                <!--        用户管理-->
                                <span v-else>{{userMap[row[field.fieldEng]]}}</span>
                            </template>
                        </el-table-column>
                        <!--       多选转义值（默认分割样式）-->
                        <el-table-column v-else-if="field.fieldInputType == 7 || field.fieldInputType == 9" :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip>
                            <template slot-scope="{row}">
                                <!--        字典项-->
                                <span v-if="field.fieldDicKeyInputFormat == 1">
                        <j-dictionary class="record-ledger-text-item" v-for="(fieldItem, i) in row[field.fieldEng]" :key="fieldItem + '-' + i" :code="field.fieldDicKey" :value="fieldItem" />
                </span>
                                <!--        用户管理-->
                                <span v-else>
                  <span class="record-ledger-text-item" v-for="(fieldItem, i) in row[field.fieldEng]" :key="fieldItem + '-' + i">{{userMap[fieldItem] || fieldItem}}</span>
                </span>
                            </template>
                        </el-table-column>
                        <!--       地址值转义-->
                        <el-table-column v-else-if="field.fieldInputType == 11" :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip>
                            <j-address slot-scope="{row}" type="text" v-model="row[field.fieldEng]" value-type="String" />
                        </el-table-column>
                        <!--       所属区划转义-->
                        <el-table-column v-else-if="field.fieldInputType == 12" :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip>
                            <j-grid-ctrl slot-scope="{row}" v-model="row[field.fieldEng]" :rule="[6, 9, 12, 14]" />
                        </el-table-column>
                        <!--       所属机构转义-->
                        <el-table-column v-else-if="field.fieldInputType == 13" :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip>
                            <span slot-scope="{row}">{{$store.state.orgMap[row[field.fieldEng]]}}</span>
                        </el-table-column>
                        <!--       字段直接渲染-->
                        <el-table-column v-else :width="widthStyle(field)" :label="field.fieldName" :prop="field.fieldEng" :key="field.fieldModelId" show-overflow-tooltip />
                    </template>
                    <el-table-column label="操作" width="140">
                        <template slot-scope="{ row }">
                            <el-button @click.stop="detailDgmxEvent(row)" class="el-button el-button--text common-button-detail">查看</el-button>
                            <el-button @click.stop="editDgmxEvent(row)" class="el-button el-button--text common-button-edit">编辑</el-button>
                            <el-button @click.stop="delEvent(row)" class="el-button el-button--text common-button-del">删除</el-button>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column v-else label="未配置列表显示字段" align="center" />
            </el-table>
        </div>
        <div slot="pagination" v-show="query.total > query.limit">
            <el-pagination :current-page="query.page" :page-size="query.limit" :total="query.total" :background="pmxBackground" :pager-count="pmxCount" :layout="pmxLayout" :pageSizes="pmxSizes" @current-change="changePage" @size-change="sizeChange" />
        </div>
        <!--        新增/编辑/详情弹窗-->
        <el-dialog v-if="showDgmx" :title="dgmxTypeMap[dgmxType]" :visible.sync="showDgmx" width="500px" top="5%" :close-on-click-modal="false">
            <div style="overflow-y: auto;max-height: 600px;overflow-x: hidden;padding-right: 6px;" v-if="showDgmx">
                <rule-form ref="ruleFormDom" :meta="formList" :forms="forms" :rules="rules" :loadDic="loadDic" @save="saveDgmxData" :read-only="dgmxType === 'DET'" :auto-full="dgmxType === 'ADD'" />
            </div>
            <template slot="footer" v-if="dgmxType !== 'DET'">
                <el-button type="primary" plain @click="showDgmx = false">取消</el-button>
                <el-button type="primary" @click="$refs['ruleFormDom'].validateData()" :loading="submitLoad">保存</el-button>
            </template>
        </el-dialog>
        <!--            搜索-->
        <el-dialog title="搜索" :visible.sync="showSearch" width="600px" top="5%" :close-on-click-modal="false">
            <div style="max-height: 600px;overflow-y: auto">
                <trend-search ref="ComplexSearchDom" :ledgerId="ledgerId" />
            </div>
            <template slot="footer">
                <el-button @click="resetComplexSearch">重置</el-button>
                <el-button type="primary" @click="complexSearch" >查询</el-button>
            </template>
        </el-dialog>
    </j-page>
</template>

<script>
    import TrendPageMixins from "./TrendPageMixins";
    export default {
        name: "TrendPage",
        mixins: [TrendPageMixins],
        data () {
            return {
                ledgerId: '' // ledgerId在注册菜单时赋值
            }
        }
    }
</script>

<style lang="scss">
    .trend-page-search {
        margin: 0 10px 10px 0;
        .el-badge__content.is-fixed {
            right: 40px;
        }
    }
    .table-fix {
        display: flex;
        flex-direction: column;
        .el-table__body-wrapper {
            flex: 1;
        }
    }
</style>
